$ = require 'jquery'

class Loader

  constructor: (src) ->
    console.log('Создаю значек загрузки...')

    this.$el = $ '<div/>',
      class: 'loader'
    $img = $ '<img/>',
      src: src
    this.$el.append($img)

    $overlay = $('.overlay')
    unless $overlay.length
      $overlay = $ '<div/>',
        class: 'overlay'
      $('body').append($overlay)

    $overlay.show()
    this.$overlay = $overlay
    $('body').append(this.$el)

  show: (time = 0) =>
    this.$el.show()
    this.$overlay.show()

    if time > 0
      setTimeout =>
        @hide()
      , time

  hide: =>
    this.$el.hide()
    this.$overlay.hide()

module.exports = Loader
